'use client'

import { createContext, useContext, useMemo, useState, type ReactNode } from 'react'

export type MobileNavigationAction = {
  ariaLabel: string
  kind: 'archive' | 'settings'
  to: string
}

export type MobileNavigationState = {
  action?: MobileNavigationAction
  backTo: string | null
  onBack?: () => void
  subtitle?: string | null
  title: string
}

type MobileNavigationContextValue = {
  navigation: MobileNavigationState | null
  setNavigation: (navigation: MobileNavigationState | null) => void
}

const MobileNavigationContext = createContext<MobileNavigationContextValue | null>(null)

export function MobileNavigationProvider({ children }: { children: ReactNode }) {
  const [navigation, setNavigation] = useState<MobileNavigationState | null>(null)
  const value = useMemo(() => ({ navigation, setNavigation }), [navigation])
  return <MobileNavigationContext.Provider value={value}>{children}</MobileNavigationContext.Provider>
}

export function useMobileNavigation() {
  const value = useContext(MobileNavigationContext)
  if (value === null) throw new Error('useMobileNavigation must be used inside MobileNavigationProvider.')
  return value
}
